export const getDeviceVideosPending = (state) =>
  state.devicesVideosReducer?.pending
